<!-- Footer -->
<footer class="footer">
  <div class="container">
    <div class="footer__content">
      <a href="https://mma.gob.cl">
        <img class="logotype" alt="Logo MMA" src="assets/images/anid_rojo_azul.png">
      </a>
      <div class="footer__col">
        <h6>ATENCIÓN CONTINGENCIA COVID - 19</h6>
        <ul>
          <li>
            <a href="https://ayuda.anid.gob.cl/hc/es/articles/4404035139092-Vías-de-Recepción-Documental" target="_blank">Oficina de Partes</a>
          </li>
          <li>
            <a href="https://mesaayudadaf.anid.cl" target="_blank">Rendiciones</a>
          </li>
          <li>
            <a href="https://ayuda.anid.gob.cl/hc/es" target="_blank">Ayuda ANID</a>
          </li>
          <li>
            <a href="https://x.com/anidinforma" target="_blank">*Síganos en Twitter</a>
          </li>
        </ul>
        <p>Moneda 1375, Santiago de Chile Mesa Central +56 2 23654400</p>
      </div>
      <div class="footer__col">
        <h6>INSTITUCIONAL</h6>
        <ul>
          <li>
            <a href="https://anid.cl/conoce-anid/" target="_blank">Conoce ANID</a>
          </li>
          <li>
            <a href="https://anid.cl/cuenta-publica-institucional/" target="_blank">Cuenta Pública Institucional</a>
          </li>
          <li>
            <a href="https://anid.cl/politica-de-privacidad/" target="_blank">Políticas de Privacidad</a>
          </li>
          <li>
            <a href="https://csirt.gob.cl/" target="_blank">Acerca de Ciberseguridad</a>
          </li>
          <li>
            <a href="https://anid.cl/integridad-institucional/" target="_blank">Integridad Institucional</a>
          </li>
          <li>
            <a href="https://anid.cl/tramites-digitales/" target="_blank">Trámites Digitales</a>
          </li>
        </ul>
      </div>
      <div class="footer__col">
        <h6>EMPLEOS</h6>
        <ul>
          <li>
            <a href="https://www.empleospublicos.cl/pub/convocatorias/convocatorias.aspx?institucion=Comisión-Nacional-de-Investigación-Científica-y-Tecnológica-CONICYT&i=412." target="_blank">Trabaja con nosotros</a>
          </li>
          <li>
            <a href="https://www.empleospublicos.cl" target="_blank">Empleos públicos</a>
          </li>
          <li>
            <a href="https://adp.serviciocivil.cl/concursos-spl/opencms/?utm_source=serviciocivil&utm_medium=banner&utm_campaign=redirecciones" target="_blank">Concursos de Alta Dirección Pública</a>
          </li>
        </ul>
      </div>
      <div class="footer__col">
        <h6>RELACIONADOS</h6>
        <ul>
          <li>
            <a href="https://www.conicyt.cl" target="_blank">Comisión Nacional de Investigación Científica y Tecnológica (CONICYT)</a>
          </li>
          <li>
            <a href="https://www.minciencia.gob.cl" target="_blank">Ministerio de Ciencia, Tecnología, Conocimiento e Innovación</a>
          </li>
          <li>
            <a href="https://www.corfo.gob.cl/sites/cpp/" target="_blank">Corporación de Fomento, Corfo</a>
          </li>
        </ul>
      </div>
      <div class="footer__col">
        <h6>GOBIERNO TRANSPARENTE</h6>
        <ul>
          <li>
            <a href="www.portaltransparencia.cl/PortalPdT/pdtta/-/ta/AJ008" target="_blank">Transparencia</a>
          </li>
          <li>
            <a href="https://www.leylobby.gob.cl/instituciones/AJ008" target="_blank">Ley de Lobby</a>
          </li>
          <li>
            <a href="https://www.portaltransparencia.cl/PortalPdT/directorio-de-organismos-regulados/?org=AJ008&pagina=43611126" target="_blank">Compromiso de Gestión Institucional</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>
